import Rest from '@/services/Rest';

export default class BillingAvailableForGenerate extends Rest {

    static resource = 'omie/billing-avalilable-for-generate'
}
